import $ from 'jquery';
import debounce from 'lodash.debounce';
import lozad from 'lozad';
import WindowUtil from "./windowUtil";
import Swiper, { Autoplay } from 'swiper';

// サイト全体で使うもの、特定のページに限定されないもの
export default class Common {
   constructor() {
      this.windowUtil = new WindowUtil();

      this.$window = $(window);
      this.$globalNav = $('.js-globalNav');
      this.globalNavHeight = this.$globalNav.outerHeight();//borderを含めナビゲーションのheightを取得
      this.windowWidth = window.innerWidth; // ブラウザのスクロールバーも含めて横幅を取得
      this.scrollCount = null;
      this.footerSwiper = null;
      this.footerSwiperMode = 'small';

      // loazed.js
      // Intersection ObserverによるLazyLoad
      // ref:https://qiita.com/yukagil/items/369a9972fd45223677fd
      // ref:https://www.rectus.co.jp/archives/358#IE_Polyfill
      const observer = lozad();
      // const observer = lozad('.lozad', {
      //     load: function(el) {
      //         // Custom implementation to load an element
      //         el.src = el.getAttribute('data-lozad-src');
      //     }
      // });
      observer.observe();

      // MicroModal.init();
      // usage https://micromodal.vercel.app/
      // -- trigger: <a href="javascript:void(0)" data-micromodal-trigger="modal-1">Open modal</a>
      // -- modal: <div class="modal micromodal-slide" id="modal-1" aria-hidden="true"></div>

      this.setEventHandlers();
      this.toggleHamburgerMenu();

      this.initSwiper();

      // mediaQuery初期チェック
      if (this.windowUtil.matchMediaQueryXsmall.matches) {
         // some....
      } else if (this.windowUtil.matchMediaQuerySmall.matches) {
         // some....
      } else if (this.windowUtil.matchMediaQueryMedium.matches) {
         // some....
      } else if (this.windowUtil.matchMediaQueryLarge.matches) {
         // some....
         this.toggleGlobalNavigation();
      } else {
         // some....
         this.toggleGlobalNavigation();
      }

      // mediaQueryのchangeをウォッチする
      this.windowUtil.matchMediaQueryXsmall.addEventListener('change', (e) => {
         if (e.matches) {
               // some....
         }
      });
      this.windowUtil.matchMediaQuerySmall.addEventListener('change', (e) => {
         if (e.matches) {
               // some....
         }
      });
      this.windowUtil.matchMediaQueryMedium.addEventListener('change', (e) => {
         if (e.matches) {
               // some....
         }
      });
      this.windowUtil.matchMediaQueryLarge.addEventListener('change', (e) => {
         if (e.matches) {
               // some....
         }
      });
      this.windowUtil.matchMediaQueryXlarge.addEventListener('change', (e) => {
         if (e.matches) {
               // some....
         }
      });
   }

   setEventHandlers() {
      $('.js-stopPropagation').on('click', (e) => {
         this.stopPropagation(e);
      });
      $('.js-embedContentControlLayer').on('click touchstart', (e) => {
         this.onClickEmbedContentControlLayer(e);
      });
      $(document).on('click touchstart', (e) => {
         if (!$(e.target).closest('.js-embedContentControlLayer').length) {
            this.removeStyleFromEmbedContentControlLayer();
         }
      });
   }

   //ハンバーガーメニューの開閉
   toggleHamburgerMenu() {
      let scrollPosition = null;
      $('.js-globalNavTriggerBtn').on('click', (e) => {
         const $body = $('body');
         const navStatus = $('body').attr('data-nav-status');
         // $('.js-globalNavToggleContent').slideToggle();
         $('.js-globalNavToggleContent').toggleClass('is-open');
         $(e.currentTarget).toggleClass('is-open');
         if (!navStatus || navStatus == 'is-close') {
            scrollPosition = this.$window.scrollTop();
            $body.attr('data-nav-status', 'is-open');
            $body.css('top', -scrollPosition);
            $('.js-nav-mask').css('top', scrollPosition);
         } else {
            $body.attr('data-nav-status', 'is-close');
            $body.removeAttr('style');
            window.scrollTo(0, scrollPosition);
         }
      });
      $('.js-nav-close, .js-nav-mask').on('click', function () {
         $('body').attr('data-nav-status', 'is-close').removeAttr('style');
         window.scrollTo(0, scrollPosition);
         $('.js-globalNavToggleContent, .js-globalNavTriggerBtn').removeClass('is-open');
      });
   }

   //スクロールに応じたglobal navigationの表示制御
   toggleGlobalNavigation() {
      let startScrollPos = 0;
      this.$window.on('scroll', debounce(() => {
         this.scrollCount = this.$window.scrollTop();
         if (this.scrollCount > startScrollPos) {
               //下方向のスクロール時
               if (this.scrollCount > this.globalNavHeight) {
                  this.$globalNav.removeClass('is-show').addClass('is-hide');
                  this.$globalNav.on('transitionend', () => {
                     this.$globalNav.addClass('is-fixed');
                  });
               } else {
                  this.$globalNav.removeClass('is-hide is-show');
               }
         } else {
               //上方向のスクロール時
               this.$globalNav.removeClass('is-hide').addClass('is-show');
               if (this.scrollCount < this.globalNavHeight) {
                  this.$globalNav.removeClass('is-hide is-show');
                  this.$globalNav.on('transitionend', () => {
                     this.$globalNav.removeClass('is-fixed');
                  });
               }
         }
         startScrollPos = this.$window.scrollTop();
      }, 200));
   }

   //ページ遷移時にアンカーリンク指定があった場合にfixedヘッダー分の位置を調整
   fixAnkerLinkScrollPosition() {
      //URLのハッシュ値を取得
      const urlHash = location.hash;
      //ハッシュ値があればページ内スクロール
      if (urlHash) {
         const targetPosition = $(urlHash).offset().top;
         $(window).scrollTop(targetPosition - this.globalNavHeight);
      }
   }

   //イベント伝播ストップIE対応
   stopPropagation(e) {
      if (e.stopPropagation) {
         e.stopPropagation();
      } else {
         e.cancelBubble = true;
      }
   }

   setupSwiper(modules, el, options) {
      if (!$(el).length) {
         return;
      }
      // configure Swiper to use modules
      Swiper.use(modules);
      // init Swiper:
      return new Swiper(el, options);
   }

   initSwiper() {
      const swiperModlues = [Autoplay];
      const swiperContainer = '[data-swiper-element="footerBanner"]';
      const swiperOptions = {
         autoplay: {
            delay: 0,
         },
         speed: 6000,
         loop: true,
         slidesPerView: 1,
      };

      // mediaQuery初期チェック
      if (this.windowUtil.matchMediaQueryXsmall.matches || this.windowUtil.matchMediaQuerySmall.matches) {
         swiperOptions.slidesPerView = 0.8;
         this.footerSwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
         this.footerSwiperMode = 'small';
      } else {
         swiperOptions.slidesPerView = 1.2;
         this.footerSwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
         this.footerSwiperMode = 'large';
      }
      // mediaQueryのchangeをウォッチする
      this.windowUtil.matchMediaQueryXsmall.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.footerSwiper && this.footerSwiperMode !== 'small') {
               console.log('xsmall if');
               this.footerSwiper.destroy(false, false);
               swiperOptions.slidesPerView = 0.8;
               this.footerSwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.footerSwiperMode = 'small';
            }
         }
      });
      this.windowUtil.matchMediaQuerySmall.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.footerSwiper && this.footerSwiperMode !== 'small') {
               console.log('small if');
               this.footerSwiper.destroy(false, false);
               swiperOptions.slidesPerView = 0.8;
               this.footerSwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.footerSwiperMode = 'small';
            }
         }
      });
      this.windowUtil.matchMediaQueryMedium.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.footerSwiper && this.footerSwiperMode !== 'large') {
               console.log('medium if');
               this.footerSwiper.destroy(false, false);
               swiperOptions.slidesPerView = 1.2;
               this.footerSwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.footerSwiperMode = 'large';
            }
         }
      });
      this.windowUtil.matchMediaQueryLarge.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.footerSwiper && this.footerSwiperMode !== 'large') {
               this.footerSwiper.destroy(false, false);
               swiperOptions.slidesPerView = 1.2;
               this.footerSwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.footerSwiperMode = 'large';
            }
         }
      });
      this.windowUtil.matchMediaQueryXlarge.addEventListener('change', (e) => {
         if (e.matches) {
            if (!!this.footerSwiper && this.footerSwiperMode !== 'large') {
               this.footerSwiper.destroy(false, false);
               swiperOptions.slidesPerView = 1.2;
               this.footerSwiper = this.setupSwiper(swiperModlues, swiperContainer, swiperOptions);
               this.footerSwiperMode = 'large';
            }
         }
      });
   }

   onClickEmbedContentControlLayer(e) {
      // 2回発火を避けるための処理
      if(e.type == "touchstart"){
         e.preventDefault(); // 必要に応じて追加
      }
      const $target = $(e.currentTarget);
      // $targetが.hoveredを持っていない場合は処理を終了
      if ($target.hasClass('hovered')) {
         $target.css('display', 'none');
         $target.removeClass('hovered');
      } else {
         $target.addClass('hovered');
      }
   }

   removeStyleFromEmbedContentControlLayer() {
      $('.js-embedContentControlLayer').removeAttr('style');
      $('.js-embedContentControlLayer').removeClass('hovered');
   }
};
